import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import DefaultSelectMenu from 'components/selectMenu/DefaultSelectMenu';
import styled from 'styled-components';
import { color } from 'asserts/styles/colors';
import Service from 'components/terms/Service';

const ServiceTerms = () => {
  const dummyData = [
    { value: '서비스이용약관 2024.02.21(최신)', label: '서비스이용약관 2024.02.21(최신)' }
  ];

  const navigate = useNavigate();

  const handleChoiceSelectBox = () => {
    console.log('.');
  };

  const handleClickMovePage = () => {
    navigate('/terms/individual');
  };

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Wrapper>
      <SelectMenuWrapper>
        <DefaultSelectMenu
          defaultValue={dummyData[0].label}
          options={dummyData}
          onChange={handleChoiceSelectBox}
        />
      </SelectMenuWrapper>
      <ContentsWrapper>
        <TabsWrapper>
          <div>서비스이용약관</div>
          <div onClick={handleClickMovePage}>개인정보처리방침</div>
        </TabsWrapper>
        <TermsContents>
          <Service />
        </TermsContents>
      </ContentsWrapper>
    </Wrapper>
  );
};

export default ServiceTerms;

const Wrapper = styled.div`
  width: 890px;
  gap: 8px;
  margin: 0 auto;
  padding-top: 72px;
  color: ${color.gray600};
  line-height: normal;
`;

const ContentsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 65px;

  h3 {
    font-size: 18px;
    font-weight: 700;
  }

  p {
    font-size: 14px;
  }
`;

const TabsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 240px;
  text-align: right;
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;

  & div:last-of-type {
    color: ${color.gray400};
  }

  & div {
    cursor: pointer;
  }

  position: sticky;
  top: 112px;
  height: max-content;
`;

const TermsContents = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 585px;

  strong {
    font-weight: bold;
  }
`;

const SelectMenuWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  margin: 0 auto 24px;

  .ant-select {
    min-width: 280px;

    .ant-select-selection-item {
      font-size: 13px;
    }
  }
`;
